import React, { FC, Fragment } from 'react';

import {
  ContentApprovalTypes,
  GroupFragment,
  SearchContentQueryVariables,
  SearchContentSortFields,
  SortDirections,
} from 'api';
import { Desktop, Layouts, Mobile } from 'components';
import { useSearchContent } from 'features/admin/hooks';

import DesktopBanner from './DesktopBanner';
import MobileBanner from './MobileBanner';
import ModeratorFeed from './ModeratorFeed';

interface Props {
  group: GroupFragment;
  variables: SearchContentQueryVariables;
}

const GroupModeratorTabs: FC<Props> = ({ group, variables }) => {
  const queryOptions = useSearchContent({
    search_content: {
      ...variables.search_content,
      sort_by: [
        {
          direction:
            variables.search_content.approval === ContentApprovalTypes.Removed
              ? SortDirections.Desc
              : SortDirections.Asc,
          field: SearchContentSortFields.PublishAt,
        },
      ],
    },
  });

  function getEmptyStateName() {
    switch (variables.search_content.approval) {
      case ContentApprovalTypes.Removed:
        return 'groupRemoved';
      case ContentApprovalTypes.Scheduled:
        return 'groupScheduled';
      default:
        return 'groupApproval';
    }
  }

  function renderFeed() {
    return (
      <ModeratorFeed
        emptyStateName={getEmptyStateName()}
        selectedGroup={group}
        variables={variables}
        {...queryOptions}
      />
    );
  }

  function renderBanner() {
    return (
      <Fragment>
        <Desktop>
          <DesktopBanner group={group} />
        </Desktop>
        <Mobile>
          <MobileBanner isFollowing group={group} />
        </Mobile>
      </Fragment>
    );
  }

  return (
    <Layouts.AppMain2Column
      desktopSplit="8/4"
      header={renderBanner()}
      left={renderFeed()}
      right={null}
    />
  );
};

export default GroupModeratorTabs;
